import {
	DELETE_ORGANIZATION_ROLE,
	DELETE_ORGANIZATION_ROLE_SUCCESS,
	DELETE_ORGANIZATION_ROLE_FAIL,
	DELETE_ORGANIZATION_ROLE_RESET,
} from '../actions/deleteOrganizationRoleAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const deleteOrganizationRoleReducer = (state = initialState, action) => {
	switch (action.type) {
		case DELETE_ORGANIZATION_ROLE:
			return {
				...state,
				apiState: 'loading',
			};
		case DELETE_ORGANIZATION_ROLE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case DELETE_ORGANIZATION_ROLE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case DELETE_ORGANIZATION_ROLE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default deleteOrganizationRoleReducer;
